export default __webpack_public_path__ + "static/media/exploded-view_sprite.0ed320c4.png";